export default [
  { name: "our story", to: "our-story" },
  { name: "consultancy", to: "consultancy" },
  { name: "software", to: "software" },
  { name: "contact", to: "contact" },
  { name: "blog", to: "https://blog.antecna.com"}
];
